import {Result, URLSearchParamsBuilder} from "@zhoujianhui/vip-core";
import axios from "axios";

const intelligentJudgmentService = {

    //获取国家字典表
    async getCountryList() {
        try {
            const response = await axios.get('/countries')
            return Result.success("所属国查询成功").data(response.data).build();
        } catch (error) {
            return Result.error("所属国查询失败" + error.message).build();
        }
    },

    // 智能判定历史
    async getIntelligentJudgmentsByQueryAndPageable(query, pageable) {
        const params = new URLSearchParamsBuilder()
            .appendObject(query)
            .appendPageable(pageable)
            .build()

        try {
            const response = await axios.get(`/smartcomp/history`, {
                params: params
            });
            return Result.success("智能判定历史查询成功！").data(response.data).build();
        } catch (error) {
            return Result.error("智能判定历史查询失败！" + error.message).build();
        }
    },

    //根据国家和hsCode查询关税税率
    async getTaxByHsCodeAndCountry(tariffFtaDto) {
        try {
            const response = await axios.get('/tariff-infos', {
                params: tariffFtaDto
            })
            return Result.success("查询关税信息成功").data(response.data).build();
        } catch (error) {
            return Result.error("查询关税信息失败" + error.message).build();
        }
    },

}

export default intelligentJudgmentService
